var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:_vm.isShowing
        ? 'content'
        : _vm.background
        ? 'background-color'
        : 'background-image'},[(_vm.isLoadingTheme && !_vm.isShowHeader)?_c('Header'):_vm._e(),_c('div',{staticClass:"container-router"},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }